import { LessonType, ModuleType } from '../../../types'

export const getModuleCompletedPercentage = (module?: ModuleType) => {
  if (!module?.lessons) {
    return 0
  }

  const completedLessons: LessonType[] = []

  for (const lesson of module.lessons) {
    if (lesson.isCompleted) {
      completedLessons.push(lesson)
    }
  }

  const quotient = completedLessons.length / module.lessons.length
  return quotient * 100
}
